import { atom } from 'jotai';
import { ICompanyDataModel } from '../../../../data-models/company.data-model';
import { BulkTemplateAssignmentError } from '../../../../schemas/BulkTemplateAssignmentResponse.schema';
import { IKpiCompanyData } from './AllCompaniesData';

export type KpiCompaniesAction =
  | 'assign'
  | 'clearTemplates'
  | 'confirmStopReporting'
  | 'createRequest'
  | 'deleteAssignment'
  | 'editAssignment'
  | 'manage';

export const allCompaniesActionStateJ = atom<KpiCompaniesAction | null>(null);

/**
 * Snapshot of selected companies at the time of action (can change inside
 * the form). Determines the number of steps in the stepper so the step
 * count doesn't change with user interaction.
 *
 * For current form data, see `currentFormCompanyDataStateJ` in
 * `AssignTemplateFormState.ts` and `useCompaniesWithMissingData` in
 * `AllCompaniesForms/useValidateCompanyData.ts`.
 */
export const selectedKpiCompaniesStateDCJ = atom<(ICompanyDataModel | IKpiCompanyData)[]>([]);

export const selectedAssignmentIdStateJ = atom<number | null>(null);

export const assignmentErrorsStateJ = atom<BulkTemplateAssignmentError[] | null>(null);
